const items = [
  <p key="1">
    ชุดเอกสาร <strong>จำนวน 69 รายการ</strong> ประกอบไปด้วย ขั้นตอน, แบบฟอร์ม,
    เช็คลิสต์, พรีเซ็นเทชั่น และ แหล่งข้อมูลที่เป็นประโยชน์อื่น&nbsp;ๆ
  </p>,
  <p key="2">
    ปรึกษาผู้เชี่ยวชาญผ่านอีเมลได้ <strong>ฟรี!&nbsp;1&nbsp;เดือน</strong>
  </p>,
  <p key="3">บริการอัปเดตชุดเอกสารของเราให้ 12&nbsp;เดือนหลังจากซื้อ</p>,
  <p key="4">
    เอกสารที่ดาวน์โหลดสามารถใช้งานได้
    <br />
    ตลอดการได้รับใบอนุญาตประกอบธุรกิจ
  </p>,
  <p key="5">ชุดเอกสารใช้สำหรับ&nbsp;1&nbsp;บริษัท แต่ไม่จำกัดผู้ใช้งาน</p>,
]

export default {
  items,
}
